// extracted by mini-css-extract-plugin
export default {"root":"FloatingComponent_root__+PzOt"};